import { render, staticRenderFns } from "./DmpPanelInformation.vue?vue&type=template&id=1bd5ac94"
import script from "./DmpPanelInformation.vue?vue&type=script&lang=js"
export * from "./DmpPanelInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports